import { useState, useCallback } from "react";

export function useObjectState<T extends object>(initialState: T) {
  const [state, setState] = useState<T>(initialState);

  const setPartial: SetObjectState<T> = useCallback(
    (patch) => {
      setState((prev) => ({
        ...prev,
        ...(typeof patch === "function" ? patch(prev) : patch),
      }));
    },
    [setState],
  );

  return [state, setPartial] as const;
}

export type SetObjectState<T extends object> = (
  patch: Partial<T> | ((prev: T) => Partial<T>),
) => void;
